export const SET_PROFILE_DETAILS = 'SET_PROFILE_DETAILS';
